// Trigger show/hide of <LoadingState /> in the child components
export const REQUEST_PENDING = 'REQUEST_PENDING';
export const REQUEST_COMPLETE = 'REQUEST_COMPLETE';

// Specific type to handle when AuthLayout shows/hides <LoadingState context="fullPageTakeOver" />
export const FULL_PAGE_LOADING_STATE = 'FULL_PAGE_LOADING_STATE';



// WEBPACK FOOTER //
// ./src/actions/loadingState/types.js